var __jsx = React.createElement;
import React from "react";
import { CarCardPlaceHolder } from "./CarCardPlaceHolder";
import stl from './CarCardPlaceHolder.module.css';

/** ---------------------------------------- */

/** ---------------------------------------- */

export var CarCardPlaceHolderGrid = function CarCardPlaceHolderGrid(_ref) {
  var length = _ref.length,
    _ref$columnWidth = _ref.columnWidth,
    columnWidth = _ref$columnWidth === void 0 ? 275 : _ref$columnWidth;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.cardsWrapper,
    style: {
      gridTemplateColumns: "repeat(auto-fill, minmax(".concat(columnWidth, "px, 1fr))")
    }
  }, Array.from({
    length: length
  }).map(function (_, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "fragment" + index
    }, /*#__PURE__*/React.createElement(CarCardPlaceHolder, {
      key: "car-placeholder-".concat(index)
    }));
  }));
};